import { ActionBase } from '../../../core/store/action/ActionBase';
import { ModuleConfiguration } from '../../datawarehouse.module.config';

export const SYNC_WITH_NEXTGATE = `[${ModuleConfiguration.moduleName}] Sync With Nextgate`;

export class SyncWithNextgateAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = SYNC_WITH_NEXTGATE;

  constructor(public payload: { key: string, isNew: boolean, currentAction: string }) {}
}


// WEBPACK FOOTER //
// ./src/app/datawarehouse/store/actions/SyncWithNextgateAction.ts